// extracted by mini-css-extract-plugin
export default {"planBadge":"planBadge_planBadge__A+xLv","planWarningBadge":"planBadge_planWarningBadge__Fh4yy","badge":"planBadge_badge__VOiac"};